import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { PhotoOutlined } from "@material-ui/icons";

const styles = () => ({
    container: {
        display: "flex",
        alignItems: "center"
    },
    text: {
        cursor: "pointer",
        textDecoration: "underline",
        marginRight: 4
    }
});

const OccupiedCapacityRenderer = ({ classes, value }) => {
    return value && (<div className={classes.container}>
        <span className={classes.text}>
            {value}
        </span>
        <PhotoOutlined />
    </div>)
};

export default withStyles(styles)(OccupiedCapacityRenderer);
